<template>
  <article style="margin-top: 4px;">
    <span>
      <v-tooltip bottom>
        <v-btn slot="activator" dark icon small flat @click.native="dialog = !dialog">
          <svg class="customIcon i_action"  viewBox="0 0 24 24">
              <path fill="#000000" d="M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z" />
          </svg>
        </v-btn>
        <span>Visualizar Endereço / Inf. adicionais</span>
      </v-tooltip>
    </span>

    <v-layout row justify-center>
      <v-dialog
        @keydown.esc="dialog = false"
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark class="headline darkBlue">
            <v-toolbar-title>Informações adicionais do {{component.text}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="printInfos()">
              <v-icon>print</v-icon>
            </v-btn>

            <v-btn icon dark @click.native="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <article :id="`infoBody_${this.forn._id}`">
            <v-list three-line subheader>
              <!-- {{forn}} -->
              <v-subheader>
                <h2>{{component.text}}:</h2>
              </v-subheader>
              <v-layout row wrap>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Razão Social:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{forn.xNome}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3 v-if="component.name == 'fornecedores'">
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Nome fantasia:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{ forn.xFant}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>CNPJ/CPF:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span
                          class="fundo_destaque"
                        >{{forn.CNPJ != undefined ? (forn.CNPJ.length > 11 ? forn.CNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : forn.CNPJ.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{component.name == 'fornecedores' ? 'Compras:' : 'Vendas:'}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{ forn.qtd}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>

                 <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{component.name == 'fornecedores' ? 'Serviço Tomado:' : 'Serviço Prestado:'}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{ forn.qntServico}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>

                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Menor Valor de {{component.name == 'fornecedores' ? 'Compra:' : 'Venda:'}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span
                          class="fundo_destaque"
                        >{{ forn.vlrMin.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Maior Valor de {{component.name == 'fornecedores' ? 'Compra:' : 'Venda:'}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span
                          class="fundo_destaque"
                        >{{ forn.vlrMax.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Primeira {{component.name == 'fornecedores' ? 'Compra:' : 'Venda:'}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{ forn.dtPrimeiraCompra != undefined ? forn.dtPrimeiraCompra.toLocaleDateString('pt-BR') : ''}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Última {{component.name == 'fornecedores' ? 'Compra:' : 'Venda:'}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{ forn.dtUltimaCompra != undefined ? forn.dtUltimaCompra.toLocaleDateString('pt-BR') : ''}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Data de Inclusão:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{ forn.dtInclusao != undefined ? new Date(forn.dtInclusao).toLocaleDateString('pt-BR') : ''}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Inscrição Estadual:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{ forn.IE}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3 v-if="component.name == 'fornecedores'">
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Regime:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{forn.CRT}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>
            </v-list>
            <v-divider></v-divider>
            <v-list three-line subheader>
              <v-subheader>
                <h2>Localização:</h2>
              </v-subheader>
              <v-layout row wrap>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Endereço:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{forn.enderEmit.xLgr}}, {{forn.enderEmit.nro}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Bairro:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{forn.enderEmit.xBairro}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>CEP:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span
                          class="fundo_destaque"
                        >{{forn.enderEmit.CEP.replace(/^(\d{5})(\d)/,"$1-$2")}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>UF:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{forn.enderEmit.UF}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Município:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{forn.enderEmit.xMun}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>País:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{forn.enderEmit.xPais}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3>
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Telefone:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span
                          class="fundo_destaque"
                        >{{ forn.enderEmit.fone != undefined && forn.enderEmit.fone.length == 8 ? forn.enderEmit.fone.replace(/^(\d{4})(\d)/,"$1-$2") : forn.enderEmit.fone != undefined && forn.enderEmit.fone.length == 11 ? forn.enderEmit.fone.replace(/^(\d{3})(\d{4})(\d)/,"($1) $2-$3") : forn.fone}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>
            </v-list>
            <v-divider></v-divider>
            <v-list three-line subheader>
              <v-subheader>
                <h2>Dados customizados:</h2>
              </v-subheader>

              <v-layout row wrap>
                <v-flex
                  xs6
                  sm3
                  md3
                  xl3
                  v-for="(item,i) in forn"
                  :key="item._id"
                  v-if="i.indexOf('custom_') != -1 && item.value != null && item.value.length > 0"
                >
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title style="text-transform: capitalize;">{{nomeColumn(i)}}:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{item.value}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3 v-if="noDataText">
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title
                        style="text-transform: capitalize;"
                      >Não possui informações customizadas.</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>
            </v-list>
          </article>
        </v-card>
      </v-dialog>
    </v-layout>
  </article>
</template>
<script>
export default {
  props: ["forn", "table", "component"],
  updated: function() {
    this.$nextTick(function() {});
  },
  beforeMount() {},
  data: () => ({
    dialog: false,
    notifications: false,
    sound: false,
    widgets: false,
    noDataText: true
  }),
  watch: {
    dialog: function(newV, oldV) {
      this.noDataText = true;
    }
  },
  components: {},
  methods: {
    printInfos: function() {
      var conteudo = document.getElementById(`infoBody_${this.forn._id}`)
          .innerHTML,
        tela_impressao = window.open("Motor Fiscal");
      tela_impressao.document.write(
        `<html><head><title>Motor Fiscal - ${this.component.text}</title>`
      );
      tela_impressao.document.write(
        `<style>html,body {margin: 0;padding: 0;border: 0;}.v-list__tile__content {text-align: left;flex: 1 1 auto;overflow: hidden;display: flex;align-items: flex-start;justify-content: center;flex-direction: column;}.v-list__tile__title {font-weight: bold;height: 24px;line-height: 24px;position: relative;text-align: left;}.fundo_destaque {background-color: whitesmoke;padding-left: 10px;}.flex.md3 {flex-basis: 25%;flex-grow: 0;max-width: 25%;}.flex.xs6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}.child-flex > *,.flex {flex: 1 1 auto;max-width: 100%;}.layout.wrap {flex-wrap: wrap;}   .layout.row {flex-direction: row;}.layout {display: flex;flex: 1 1 auto;flex-wrap: nowrap;min-width: 0;}</style>`
      );
      tela_impressao.document.write("</head><body >");
      tela_impressao.document.write(conteudo);
      tela_impressao.document.write("</body></html>");

      tela_impressao.window.print();
      tela_impressao.window.close();
      //   #infoBody
    },

    nomeColumn: function(i) {
      let nomeColumn = "";
      this.table.headers.forEach(element => {
        if (element.value == i) {
          nomeColumn = element.text;
        }
      });
      if (nomeColumn != "") {
        this.noDataText = false;
      }
      return nomeColumn;
    }
  }
};
</script>
<style>
.vinculoChip span.v-chip__content {
  cursor: pointer;
  font-size: 10px !important;
}
.fundo_destaque {
  background-color: whitesmoke;
  padding: 5px;
}
</style>
  



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnInfClientFornc/BtnInfClientFornc.vue